import { isDefined } from '@freelancer/utils';
import type { Project } from './projects.model';

/**
 * Checks if a project has a defined ownerId.
 */
export function projectHasOwnerId<P extends Project>(
  project: P,
): project is P & { readonly ownerId: number } {
  return isDefined(project.ownerId);
}
